// Override Settings
var bcSfSearchSettings = {
  search: {
    suggestionMode: 'test',
    //suggestionPosition: 'left',
    //suggestionStyle: 'style2',
    suggestionStyle2MainContainerSelector: '.cSearchBar',
    //suggestionMobileStyle: 'style2',
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function (suggestionElement, searchElement, searchBoxId) {
  if (this.isMobile()) {
    jQ(suggestionElement).parent().css({
      'position': 'fixed',
    });
    jQ(suggestionElement).css({
      'overflow-y': 'scroll',
      'max-height': '600px'
    });
  }
};

BCSfFilter.prototype.buildSuggestionProductList = function (searchTerm, itemData, ul, itemInfo, suggestionData) {
  var self = this;
  var result = '';
  // Buid Header
  result += this.buildSuggestionHeader(itemInfo['label'], 'product');
  // Build Did you mean
  var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
  if (dym != '') {
    result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
  }
  // Build content
  if (Object.keys(itemData).length > 0) {
    // var count = 0;
    var k;
    var itemDataLength = itemData.length;
    for (k = 0; k < itemDataLength; k++) {
      // if (count < itemInfo['number']) {
      var product = itemData[k];
      // Get product attributes
      var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
      productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
      var productUrl = this.buildProductItemUrl(product, false);
      var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
      var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
      // Get custom class / attribute
      var searchSuggestionClass = this.class.searchSuggestion;
      var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
      result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" data-label="' + this.escape(product['id']) + '" data-value="' + this.escape(product['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
      result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
      // Build Left column
      if (this.getSettingValue('search.showSuggestionProductImage')) {
        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
      }
      // Build Right column
      result += '<div class="' + searchSuggestionClass + '-right">';
      result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
      if (this.getSettingValue('search.showSuggestionProductSku')) {
        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
      }
      if (this.getSettingValue('search.showSuggestionProductVendor')) {
        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
      }

      if(product.price_max > product.price_min){
        result += '<div class="bc-sf-search-suggestion-product-range"><span class="pr-12345" style="font-family: CircularStd;font-weight: 700;">' + bcFormatMoney(product.price_min * 100) + ' - ' + bcFormatMoney(product.price_max * 100) + '</span></div>';
      } else {
        result += this.buildSuggestionProductPrice(product);
      }

      result += '</div>'; // End Right column
      result += '</a>'; // End a
      result += '</li>'; // End li
      // count++;
      // } else break;
    }
  }
  return result;
};

/* Start Search Redirect */
function submitSearchFormMobile(t, e) { e.preventDefault(); var o = bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm); o ? window.location.href = o : jQ(t).closest("form").submit() } function beforeSubmitSearchForm(t, e) { var o = jQ(t).val(), i = bcsffilter.getSearchRedirectUrl(o); i && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault(), window.location.href = i) } BCSfFilter.prototype.setSuggestionPosition = function (t) { var e = this; if ("function" == typeof getSuggestionPosition && "function" == typeof this.checkIsFullWidthSuggestionMobile) { var o = getSuggestionPosition(t), i = this.checkIsFullWidthSuggestionMobile(t) ? "top" : "top+12"; "function" != typeof e.isSuggestionStyle2 || e.isSuggestionStyle2(), "left" == o ? jQ(t).autocomplete("option", "position", { my: "left " + i, at: "left bottom", collision: "none" }) : jQ(t).autocomplete("option", "position", { my: "right " + i, at: "right bottom", collision: "none" }) } else "left" == this.getSettingValue("search.suggestionPosition") ? jQ(t).autocomplete("option", "position", { my: "left top+12", at: "left bottom", collision: "none" }) : jQ(t).autocomplete("option", "position", { my: "right top+12", at: "right bottom", collision: "none" }); if (jQ(t).length > 0 && jQ(t).on("keydown", function (o) { 13 == o.keyCode && e.enterSearchBoxEvent(t, o) }), jQ(t).closest("form").length > 0) { var n = jQ(t).closest("form").find('[type="submit"]'); n && n.length > 0 && n.each(function (e, o) { o.setAttribute("onclick", "beforeSubmitSearchForm('" + t + "', event)") }) } }, BCSfFilter.prototype.enterSearchBoxEvent = function (t, e) { var o = jQ(t).val(), i = this.getSearchRedirectUrl(o); i && (e.preventDefault(), window.location.href = i) }, BCSfFilter.prototype.getSearchRedirectUrl = function (t) { if (this.suggestionCache && this.suggestionCache.hasOwnProperty(t)) for (var e = this.suggestionCache[t], o = 0; o < e.length; o++)if ("redirect" == e[o].key && e[o].values) { var i = e[o].values; return i = (i = i.replace("https://" + bcSfFilterMainConfig.shop.domain, "")).replace("http://" + bcSfFilterMainConfig.shop.domain, "") } return "" };
/* End Search Redirect */

BCSfFilter.prototype.getSearchRedirectUrl = function (searchTerm) {
  var redirectUrl = '';
  if (searchTerm) {
    if (typeof searchTerm !== 'string') {
      searchTerm = searchTerm.toString();
    }
    searchTerm = searchTerm.trim().toLowerCase();
    if (this.suggestionCache.hasOwnProperty(searchTerm)) {
      var cachedResult = this.suggestionCache[searchTerm];
      for (var i = 0; i < cachedResult.length; i++) {
        if (cachedResult[i].key == 'redirect' && cachedResult[i].values) {
          // Check is there is a redirect
          redirectUrl = cachedResult[i].values;
          redirectUrl = redirectUrl.replace('https://' + bcSfFilterMainConfig.shop.domain, '');
          redirectUrl = redirectUrl.replace('http://' + bcSfFilterMainConfig.shop.domain, '');
        }
      }
    }
  }
  return redirectUrl;
};
